module.exports = __webpack_public_path__ + "assets/img/Strategysegment.e32543c8.png";